import { render, staticRenderFns } from "./SpotsExport.global.vue?vue&type=template&id=41835aba&lang=pug&"
import script from "./SpotsExport.global.vue?vue&type=script&lang=ts&"
export * from "./SpotsExport.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports